import React from "react";
import { Bar, BarChart, CartesianGrid, Cell, Label, LabelList, ResponsiveContainer, XAxis, YAxis } from "recharts";
import "./Rechart.css";

const Rechart = (props) => {
  const { trends = [] } = props;
  return (
    <div style={{ width: "100%", margin: "0 auto" }}>
      <ResponsiveContainer width="100%" height={200} aspect={1}>
        <BarChart
          layout="horizontal"
          barGap={40}
          barSize={30}
          style={{ borderRadius: "40px" }}
          width={250}
          height={80}
          data={trends}
        >
          <XAxis dataKey={"date"} fontSize={12} interval={0} />
          <Bar
            animationEasing="ease-in"
            isAnimationActive={false}
            dataKey="value"
            fill="#f38d9f"
            // margin={{ top: 5, right: 50, bottom: 5, left: 50 }}
          >
            <LabelList dataKey="value" position="top" stroke="rgba(0, 0, 0, 0.87)" fontSize="10px" opacity="0.7" />
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default Rechart;
